@if (termsService.showTermsModal()) {
<div class="modal-overlay">
  <div class="modal">
    <div class="modal-header">
      <div>
        <div class="modal-title">Algemene voorwaarden</div>
        <div class="modal-subtitle">Lees en accepteer de voorwaarden om verder te gaan</div>
      </div>
    </div>

    <div class="modal-tabs">
      <button
        class="tab"
        [class.active]="activeTab() === 'voorwaarden'"
        (click)="activeTab.set('voorwaarden')">
        Voorwaarden
      </button>
      <button
        class="tab"
        [class.active]="activeTab() === 'privacy'"
        (click)="activeTab.set('privacy')">
        Privacy
      </button>
      <button
        class="tab"
        [class.active]="activeTab() === 'cookies'"
        (click)="activeTab.set('cookies')">
        Cookies
      </button>
    </div>

    <div class="modal-body">
      @if (activeTab() === 'voorwaarden') {
        <app-terms-content />
      }

      @if (activeTab() === 'privacy') {
        <app-privacy-content />
      }

      @if (activeTab() === 'cookies') {
        <app-cookie-content />
      }
    </div>

    <div class="modal-footer">
      <button
        class="btn-decline"
        (click)="termsService.declineTerms()"
        [disabled]="termsService.loading()">
        Uitloggen
      </button>
      <button
        class="btn-accept"
        (click)="termsService.acceptTerms()"
        [disabled]="termsService.loading()">
        @if (termsService.loading()) {
          <span class="spinner"></span>
        } @else {
          Accepteren
        }
      </button>
    </div>
  </div>
</div>
}
